export const MICROSERVICE_IDS = {
  TELERECOVERY_ID: "1",
  DOCUMENT_SIGN_ID: "8"
}